import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=d0a9d440&"
import script from "./versions.vue?vue&type=script&lang=js&"
export * from "./versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports